/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Shift from './component/shift'
import { Spin } from 'antd'
import { CLUB_ID } from '../ClubBusiness/constants'

class ClubShift extends React.Component {
  static defaultProps = {
    shiftList: [],
    period: {
      start_time: null,
      end_time: null,
    },
  }

  componentWillUnmount() {
    this.props.getPeriod({ start_time: null, end_time: null }) //清除
  }

  render() {
    const { shiftList, period } = this.props
    return (
      <Shift
        period={period}
        shiftList={shiftList}
        fetchClubShiftList={this.props.fetchClubShiftList}
        getPeriod={this.props.getPeriod}
        fetchTimePeriod={this.props.fetchTimePeriod}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    shiftList: state.getClubShift.shiftList,
    period: state.getClubShift.period,
  }
}

export default withRouter(connect(mapStateToProps, actions)(ClubShift))



// WEBPACK FOOTER //
// ./src/containers/ClubShift/index.js